'use client';

import { useTranslations } from 'next-intl';
import { CaretUp } from 'assets/icons';
import React, { useState } from 'react';
import { useGlobalUI } from 'contexts/GlobalUIContext';
import useScrollspy from 'hooks/scroll/useScrollSpy';
import { Container } from '..';
import { getRareSections } from 'components/shared/SecondaryNavbarConfigs';
import styles from './SecondaryNavbar_Rare.module.css';

export const SecondaryNavbar_Rare = () => {
  const t = useTranslations('ring');
  const rareSections = getRareSections(t);
  const GlobalUI = useGlobalUI();

  const [isMobileNavVisible, setIsMobileNavVisible] = useState(false);

  const setActiveSection = (i: string) => {
    if (!document) return;
    document
      .getElementById(i)
      ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const Nav = (props: React.HTMLAttributes<HTMLDivElement>) => (
    <div className={`${styles.navRow} u-hide-scrollbar`} {...props} />
  );

  const MobileNav = (props: React.HTMLAttributes<HTMLDivElement>) => (
    <div className={styles.mobileNavColumn} {...props} />
  );

  const NavItem = ({
    className,
    ...props
  }: React.ButtonHTMLAttributes<HTMLButtonElement>) => (
    <button
      className={`${styles.navItem}${className ? ` ${className}` : ''}`}
      {...props}
    />
  );

  const MobileNavItem = ({
    className,
    ...props
  }: React.ButtonHTMLAttributes<HTMLButtonElement>) => (
    <button
      className={`${styles.mobileNavItem}${className ? ` ${className}` : ''}`}
      {...props}
    />
  );

  const activeId = useScrollspy(
      Object.values(rareSections).map((section) => section.id),
      60,
    );

    const SecondaryNav = (
      <Nav>
        {Object.entries(rareSections).map(([key, section]) => (
          <NavItem
            key={key}
            onClick={() => setActiveSection(section.id)}
            className={activeId === section.id ? 'active' : ''}
          >
            {section.title}
          </NavItem>
        ))}
      </Nav>
    );

    const SecondaryNavMobile = (
      <MobileNav>
        {Object.entries(rareSections).map(([key, section], index) => (
          <MobileNavItem
            key={key}
            onClick={(e) => {
              e.stopPropagation();
              setActiveSection(section.id);
              setIsMobileNavVisible(false);
            }}
            className={activeId === section.id ? 'active' : ''}
            style={{ animationDelay: `${index * 0.05}s` }}
          >
            {section.title}
          </MobileNavItem>
        ))}
      </MobileNav>
    );

    return (
      <div
        className={styles.root}
        style={{
          top: `${GlobalUI.headerVisible ? GlobalUI.headerHeight : 0}px`,
        }}
      >
        <Container onClick={() => setIsMobileNavVisible(false)} aria-hidden>
          <div className="content d-sm-none">{SecondaryNav}</div>
          <div
            className="content-mobile d-lg-none"
            onClick={(e) => {
              e.stopPropagation();
              setIsMobileNavVisible((prev) => !prev);
            }}
            aria-hidden
          >
            <p className="section-title-visible">
              {rareSections[activeId]?.title}{' '}
              <CaretUp
                fill="#000000"
                style={{ transform: 'rotate(180deg)', height: '8px' }}
              />
            </p>
            {isMobileNavVisible ? (
              <div className="mobile-nav">{SecondaryNavMobile}</div>
            ) : null}
          </div>
        </Container>
      </div>
    );
};
